<template>
  <section>
    <div class="w-full h-full" style="margin-top: -120px">
      <div class="landing-bg">
        <div
          class="spotlight"
          v-bind:style="style"
          ref="spotlight"
          @click="goToHome"
        ></div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      mouseXpercentage: 0,
      mouseYpercentage: 0
    };
  },

  computed: {
    style() {
      return {
        backgroundImage:
          "radial-gradient(circle at " +
          this.mouseXpercentage +
          "% " +
          this.mouseYpercentage +
          "%, transparent 160px, rgba(0, 0, 0, 0.95) 400px)"
      };
    },

    //to be replace by some other mapped state
    ...mapState({ count: state => state.count })
  },
  methods: {
    updateSpotlight(e) {
      let x = e.clientX;
      let y = e.clientY;
      this.mouseXpercentage = (x / window.innerWidth) * 100;
      this.mouseYpercentage = (y / window.innerHeight) * 100;
      //console.log(this.$store.state.foodMenu);
    },
    goToHome() {
      this.$router.push("home");
    }
  },
  mounted() {
    window.addEventListener("mousemove", e => this.updateSpotlight(e));
    console.log(this.$router);
  }
};
</script>

<style scoped>
.landing-bg {
  background: url("~@/assets/landing/sushi-shogun-landing-bg.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 101vh;
}
.spotlight {
  position: absolute;
  height: 101vh;
  width: 100%;
}
#poem {
  position: absolute; /* Reposition logo from the natural layout */
  left: 75px;
  top: 0px;
  width: 300px;
  height: 200px;
  z-index: 2;
}
</style>